import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  li {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { CustomMenuButton } from "@/components/Categories/Menu/DetailFilterButton";
import { FilterQueryHandlerType, useCategoryFilterHandler } from "@/hooks/useCategoryFilterHandler";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { styled } from "@mui/material";
import { SearchQueryKey } from "src/api/search";
import { CategoryFilterBox } from "./Category/DetailCategoryProducts";
import { routerOptions } from "./Search/useSearchBarHandler";
const BrandFilter = (param)=>{
    let { filterItems , handleMobileSideSheet  } = param;
    const { isCheckFilterItem , isCheckFilterCount , filterQueryHandler , searchParams  } = useCategoryFilterHandler({
        isUseAsPath: true,
        routerOptions: routerOptions
    });
    return /*#__PURE__*/ _jsx(CategoryFilterBox, {
        children: filterItems === null || filterItems === void 0 ? void 0 : filterItems.map((filter)=>filter.items.length > 0 && /*#__PURE__*/ _jsx(CustomMenuButton, {
                filterName: filter.key,
                // items={filter.items}
                mobileFilterOpen: handleMobileSideSheet,
                isCheckFilterItem: isCheckFilterItem,
                isCheckFilterCount: isCheckFilterCount,
                children: /*#__PURE__*/ _jsx(CustomMenuButton.MenuItemListLayout, {
                    children: filter.items.map((item, idx)=>{
                        if (!item) return;
                        if (filter.key === SearchQueryKey.TICKETS && typeof item === "object") {
                            return /*#__PURE__*/ _jsx(SearchLastDropdownStyle, {
                                style: {
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ _jsx(CustomMenuButton.MenuItem, {
                                    checked: isCheckFilterItem(filter.key, String(item.id)),
                                    onChange: ()=>{
                                        //mx-194 브랜드 상품탭 필터 클릭 시
                                        mixpanelEvent("Brand Products Filtered", {
                                            "Filter Type": filter.key,
                                            "Filter Option Selected": item.id
                                        });
                                        filterQueryHandler({
                                            filterType: FilterQueryHandlerType.DETAILFILTER,
                                            filterName: filter.key,
                                            value: String(item.id)
                                        });
                                    },
                                    children: item.value
                                })
                            }, filter.key + idx + item);
                        }
                        if (typeof item === "string") {
                            return /*#__PURE__*/ _jsx(CustomMenuButton.MenuItem, {
                                checked: isCheckFilterItem(filter.key, item),
                                onChange: ()=>{
                                    //mx-194 브랜드 상품탭 필터 클릭 시
                                    mixpanelEvent("Brand Products Filtered", {
                                        "Filter Type": filter.key,
                                        "Filter Option Selected": item
                                    });
                                    filterQueryHandler({
                                        filterType: FilterQueryHandlerType.DETAILFILTER,
                                        filterName: filter.key,
                                        value: item
                                    });
                                },
                                children: item
                            }, filter.name + idx + item);
                        }
                    })
                })
            }, filter.name))
    });
};
const SearchLastDropdownStyle = styled("div")(_templateObject());
export default BrandFilter;
